import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';

export function SearchIcon(props) {
	return (
		<SvgIcon {...props}>
			<path d="M10.857 21.571c-6 0-10.857-4.857-10.857-10.714s4.857-10.857 10.857-10.857 10.857 4.857 10.857 10.857-5 10.714-10.857 10.714zM10.857 2.571c-4.571 0-8.286 3.714-8.286 8.286s3.714 8.286 8.286 8.286c4.571 0 8.286-3.714 8.286-8.286-0.143-4.571-3.857-8.286-8.286-8.286zM22.714 24c-0.286 0-0.714-0.143-0.857-0.429l-5.143-5.143c-0.571-0.571-0.571-1.286 0-1.857s1.286-0.571 1.857 0l5.143 5.143c0.571 0.571 0.571 1.286 0 1.857-0.286 0.286-0.714 0.429-1 0.429z"></path>
		</SvgIcon>
	);
}

export default SearchIcon;
